"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProvider = exports.getAppointmentWaitlist = void 0;
const API_1 = require("../../../../ManageAppointment/lib/API");
const API_2 = require("../../../lib/API");
// Services
const getAppointmentWaitlist = (context) => {
    const { getWaitlistDetails } = context.services;
    return (0, API_2.getWaitlistDetailsById)(getWaitlistDetails, context.appointmentWaitlistId);
};
exports.getAppointmentWaitlist = getAppointmentWaitlist;
const getProvider = (context) => {
    var _a, _b;
    const { getProvider } = context.services;
    const providerId = ((_a = context.waitlist) === null || _a === void 0 ? void 0 : _a.original_appointment.provider.provider_pma_id) ||
        ((_b = context.waitlist) === null || _b === void 0 ? void 0 : _b.original_appointment.provider.provider_ehr_id);
    const response = (0, API_1.getProviderById)(getProvider, providerId);
    return response;
};
exports.getProvider = getProvider;
const services = {
    getAppointmentWaitlist: exports.getAppointmentWaitlist,
    getProvider: exports.getProvider
};
exports.default = services;
//# sourceMappingURL=services.loadingMachine.js.map